import ChattaCommunityCategoriesScreen from '~components/new-chat/community'

export default ChattaCommunityCategoriesScreen
